/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient, HttpRequest, HttpResponse, 
  HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators/map';
import { filter } from 'rxjs/operators/filter';

import { HistoricalSites } from '../models';

@Injectable()
export class ManagerHistoricalSitesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   */
  managerHistoricalSitesResponse(params: ManagerHistoricalSitesService.ManagerHistoricalSitesParams): Observable<HttpResponse<HistoricalSites[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.page != null) __params = __params.set("page", params.page.toString());
    if (params.limit != null) __params = __params.set("limit", params.limit.toString());
    if (params.page != null) __params = __params.set("key_input", params.key_input.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/historical-sites`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: HistoricalSites[] = null;
        _body = _resp.body as HistoricalSites[]
        return _resp.clone({body: _body}) as HttpResponse<HistoricalSites[]>;
      })
    );
  }
  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   * @param disable - The numbers of items to return.
   */
  managerHistoricalSites(params: ManagerHistoricalSitesService.ManagerHistoricalSitesParams): Observable<HistoricalSites[]> {
    return this.managerHistoricalSitesResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  managerHistoricalSitesGroupResponse(params: ManagerHistoricalSitesService.ManagerHistoricalSitesParams): Observable<HttpResponse<HistoricalSites[]>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/historical-sites-group`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: HistoricalSites[] = null;
        _body = _resp.body as HistoricalSites[]
        return _resp.clone({body: _body}) as HttpResponse<HistoricalSites[]>;
      })
    );
  }
  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   * @param disable - The numbers of items to return.
   */
  managerHistoricalSitesGroup(params: ManagerHistoricalSitesService.ManagerHistoricalSitesParams): Observable<HistoricalSites[]> {
    return this.managerHistoricalSitesGroupResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   */

  managerCreateHistoricalSitesResponse(body?: HistoricalSites): Observable<HttpResponse<HistoricalSites>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/historical-sites`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: HistoricalSites = null;
        _body = _resp.body as HistoricalSites
        return _resp.clone({body: _body}) as HttpResponse<HistoricalSites>;
      })
    );
  }

  /**
   * @param body - Created User object
   */
  managerCreateHistoricalSites(body?: HistoricalSites): Observable<HistoricalSites> {
    return this.managerCreateHistoricalSitesResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerUpdateHistoricalSitesResponse(body?: HistoricalSites): Observable<HttpResponse<HistoricalSites>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/manager/historical-sites/${body.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: HistoricalSites = null;
        _body = _resp.body as HistoricalSites
        return _resp.clone({body: _body}) as HttpResponse<HistoricalSites>;
      })
    );
  }

  /**
   * @param body - update
   */
  managerUpdateHistoricalSites(body?: HistoricalSites): Observable<HistoricalSites> {
    return this.managerUpdateHistoricalSitesResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerDeleteHistoricalSitesResponse(id: number): Observable<HttpResponse<void>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    
    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl + `/manager/historical-sites/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: void = null;
        
        return _resp.clone({body: _body}) as HttpResponse<void>;
      })
    );
  }

  /**
   * @param userId - undefined
   */
  managerDeleteHistoricalSites(id: number): Observable<void> {
    return this.managerDeleteHistoricalSitesResponse(id).pipe(
      map(_r => _r.body)
    );
  }

  managerHistoricalSitesTicketsResponse(params: { ticket_price_id: number, serial: number, historical_site_id: number }): Observable<HttpResponse<{ url: string }>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.ticket_price_id != null) __params = __params.set("ticket_price_id", params.ticket_price_id.toString());
    if (params.serial != null) __params = __params.set("serial", params.serial.toString());
    if (params.historical_site_id != null) __params = __params.set("historical_site_id", params.historical_site_id.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/historical-sites-tickets/view`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: { url: string } = null;
        _body = _resp.body as { url: string }
        return _resp.clone({body: _body}) as HttpResponse<{ url: string }>;
      })
    );
  }

  managerConfirmValidHistoricalSitesTicketResponse(body: {
    fkey: string;
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<HttpResponse<any>> {
    let __headers = new HttpHeaders();
    __headers = __headers.set('Content-Type', 'application/json');
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/historical-sites-tickets/confirm-valid`,
      body,
      {
        headers: __headers,
        responseType: 'json'
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => _r as HttpResponse<any>)
    );
  }

  managerConfirmValidHistoricalSitesTicket(body: {
    fkey: string;
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<any> {
    return this.managerConfirmValidHistoricalSitesTicketResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerConfirmInvalidHistoricalSitesTicketResponse(body: {
    fkey: string;
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<HttpResponse<any>> {
    let __headers = new HttpHeaders();
    __headers = __headers.set('Content-Type', 'application/json');
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/historical-sites-tickets/confirm-invalid`,
      body,
      {
        headers: __headers,
        responseType: 'json'
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => _r as HttpResponse<any>)
    );
  }

  managerConfirmInvalidHistoricalSitesTicket(body: {
    fkey: string;
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<any> {
    return this.managerConfirmInvalidHistoricalSitesTicketResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerRevertHistoricalSitesTicketToSuspectedResponse(body: {
    fkey: string;
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<HttpResponse<any>> {
    let __headers = new HttpHeaders();
    __headers = __headers.set('Content-Type', 'application/json');
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/historical-sites-tickets/revert-suspected`,
      body,
      {
        headers: __headers,
        responseType: 'json'
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => _r as HttpResponse<any>)
    );
  }

  managerRevertHistoricalSitesTicketToSuspected(body: {
    fkey: string;
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<any> {
    return this.managerRevertHistoricalSitesTicketToSuspectedResponse(body).pipe(
      map(_r => _r.body)
    );
  }

  managerMarkReadHistoricalSitesTicketResponse(body: {
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<HttpResponse<any>> {
    let __headers = new HttpHeaders();
    __headers = __headers.set('Content-Type', 'application/json');
    const req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/manager/historical-sites-tickets/mark-read`,
      body,
      {
        headers: __headers,
        responseType: 'json'
      }
    );
    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => _r as HttpResponse<any>)
    );
  }

  managerMarkReadHistoricalSitesTicket(body: {
    historical_site_id: number;
    serial: number;
    ticket_price_id: number;
  }): Observable<any> {
    return this.managerMarkReadHistoricalSitesTicketResponse(body).pipe(
      map(_r => _r.body)
    );
  }
}

export module ManagerHistoricalSitesService {
  export interface ManagerHistoricalSitesParams {
    page?: number;
    limit?: number;
    key_input?: string;
  }
}
